module.exports = __webpack_public_path__ + "img/mda.5f734d92.svg";